import router from "./router";
import store from "./store";
import userServices from "@/services/user";
import settingServices from "@/services/settings";
import { getToken } from "@/utils/common";

const LOCKED_ALLOWED_PATHS = ['/ticket', '/billing'];

let cachedSettings = null;

router.beforeEach(async (to, from, next) => {
  if (to.path.includes("load-balancer")) {
    let userProfile = store.state.user?.userProfile;

    if (!userProfile || !userProfile.services) {
      try {
        const response = await userServices.getUserServices();
        userProfile = { services: response.data.data };
      } catch (error) {
        console.error("Failed to fetch user services:", error);
        return next(false);
      }
    }

    const services = userProfile.services?.filter(item => item.enable).map(item => item.service);

    if (!services.includes("load_balancer")) {
      store.dispatch("updateWarningServiceModal", true);
      return;
    }
  }

  const accessToken = getToken('access_token');
  if (accessToken) {
    if (!store.state.user?.portalLockChecked) {
      try {
        const invoiceStatus = store.state.user?.userProfile?.invoice_status;
        if (invoiceStatus) {
          store.dispatch('updatePortalLocked', invoiceStatus.is_lock_portal);
          store.dispatch('updatePortalLockChecked', true);
        }
      } catch (error) {
        console.error("Failed to check portal lock:", error);
        store.dispatch('updatePortalLockChecked', true);
      }
    }

    if (store.state.user?.portalLocked) {
      const isAllowed = LOCKED_ALLOWED_PATHS.some(path => to.path.startsWith(path));
      if (!isAllowed) {
        return next('/billing');
      }
    }
  }

  next();
});
